(function (root) {
  'use strict';
  const intersects = (values, chosen) => !chosen?.length || chosen.some(value => (values || []).includes(value));
  function select(products, state = {}) {
    const result = products.filter(p => !p.campaign && p.inScope !== false &&
      (!state.goal || (p.goals || []).includes(state.goal)) &&
      intersects(p.lines, state.lines) && intersects(p.moments, state.moments) && intersects(p.methods || Object.keys(p.times || {}), state.methods) &&
      (state.traits || []).every(t => (p.traits || []).includes(t)) &&
      (!state.offers || p.comparePrice > p.price) &&
      (state.maxPortion == null || (p.servings > 0 && Math.round(p.price / p.servings) <= state.maxPortion)) &&
      (!state.time || (state.methods?.length ? state.methods : Object.keys(p.times || {})).some(m => Number.isFinite(p.times?.[m]) && p.times[m] <= Number(state.time))) &&
      (!state.format || p.format === state.format) &&
      (!state.portion || p.portion === state.portion) &&
      (!state.stock || p.available) &&
      (state.max == null || p.price <= state.max));
    if (state.sort === 'price-asc') result.sort((a,b) => a.price-b.price);
    if (state.sort === 'price-desc') result.sort((a,b) => b.price-a.price);
    return result;
  }
  function countOption(products, state, group, value) {
    const next = {...state};
    if(group === 'traits') next.traits = [...new Set([...(state.traits || []), value])];
    else if(['lines','methods','moments'].includes(group)) next[group] = [value];
    else next[group] = value;
    return select(products, next).length;
  }
  function commonMethods(components) {
    const prepared = components.filter(p => !p.preparationNotRequired);
    if (!prepared.length || prepared.some(p => !p.methods?.length)) return [];
    return prepared[0].methods.filter(method => prepared.every(p => p.methods.includes(method)));
  }
  function resolveProduct(data) {
    const p = { ...data, ...(data.facts || {}) };
    const goals = new Set(p.goals || []);
    for (const [key, included] of Object.entries(data.manualGoals || {})) {
      if (included) goals.add(key); else goals.delete(key);
    }
    return { ...p, goals: [...goals] };
  }
  const api = { select, commonMethods, countOption, resolveProduct };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.HolyObjectiveRules = api;
})(typeof window !== 'undefined' ? window : this);
